export const genericPhoneNumber = /^\+[1-9]\d{6,15}$/;
